import { error } from 'scripts/utils/message'

import { updateProject } from 'lmcv/services/customers'

import {
  FAIL_DELETE_RELATIONSHIP
} from './constants'

export const deleteRelationship = (id, onClose) => {
  updateProject(id, { status: 'cancelled' })
    .then(({ status }) => {
      onClose()
      window.location = '/fidelidade'
    })
    .catch(e => {
      error(FAIL_DELETE_RELATIONSHIP)
    })
}
